import React, { Component, Fragment } from 'react';
import api from '../../../services/api';
import './styles.css';
import { timingSafeEqual } from 'crypto';
class Company extends Component {

    state = {
        load: false,
        existCNPJ: false,
        companyTypes: {},
        states: {},
        businessUnits: [],
        msgErro: null,
        loadCreate: false,
        companyCreate: false,
        seconds: 1,
        errors: {},
        emailValidate: false,
        isEmail: false,
        isEmailNew: false,
        contacts: [],
        dataContacts: {},
        companyCreateContacts: false,
        idCompanyCreate: null,
        existCNPJAndUnit: false
    }

    componentDidMount() {
        this.searchCompanyTypes();
        this.states();
        this.loadBusinessUnits();

        var phone = document.getElementById('phone');
        phone.setSelectionRange(0, 0);
    }

    loadBusinessUnits = () => {
        try {
            const businessUnitsStr = process.env.REACT_APP_BUSINESS_UNITS || '[]';
            const businessUnits = JSON.parse(businessUnitsStr);
            this.setState({ businessUnits });
        } catch (error) {
            console.error("Error parsing business units:", error);
            this.setState({ businessUnits: [] });
        }
    }

    states = () => {
        let stat =
            [
                { "nome": "Acre", "sigla": "AC" },
                { "nome": "Alagoas", "sigla": "AL" },
                { "nome": "Amapá", "sigla": "AP" },
                { "nome": "Amazonas", "sigla": "AM" },
                { "nome": "Bahia", "sigla": "BA" },
                { "nome": "Ceará", "sigla": "CE" },
                { "nome": "Distrito Federal", "sigla": "DF" },
                { "nome": "Espírito Santo", "sigla": "ES" },
                { "nome": "Goiás", "sigla": "GO" },
                { "nome": "Maranhão", "sigla": "MA" },
                { "nome": "Mato Grosso", "sigla": "MT" },
                { "nome": "Mato Grosso do Sul", "sigla": "MS" },
                { "nome": "Minas Gerais", "sigla": "MG" },
                { "nome": "Pará", "sigla": "PA" },
                { "nome": "Paraíba", "sigla": "PB" },
                { "nome": "Paraná", "sigla": "PR" },
                { "nome": "Pernambuco", "sigla": "PE" },
                { "nome": "Piauí", "sigla": "PI" },
                { "nome": "Rio de Janeiro", "sigla": "RJ" },
                { "nome": "Rio Grande do Norte", "sigla": "RN" },
                { "nome": "Rio Grande do Sul", "sigla": "RS" },
                { "nome": "Rondônia", "sigla": "RO" },
                { "nome": "Roraima", "sigla": "RR" },
                { "nome": "Santa Catarina", "sigla": "SC" },
                { "nome": "São Paulo", "sigla": "SP" },
                { "nome": "Sergipe", "sigla": "SE" },
                { "nome": "Tocantins", "sigla": "TO" }
            ];
        this.setState({ states: stat });

    }

    searchCompanyTypes = async () => {
        this.setState({ load: true });
        const response = await api.get('/company-types');
        this.setState({ companyTypes: response.data.rows, load: false });
    }

    verifyCnpj = async (e) => {
        let value = this.transform(document.getElementById('cnpj').value);
        let businessUnit = document.getElementById('businessUnit').value;
        
        if (value.length == 14) {
            const response = await api.get(`/companies?cnpj=${value}&businessUnit=${businessUnit || 'MAIN'}`);
            if (response.data.rows && response.data.rows[0]) {
                this.setState({ existCNPJAndUnit: true });
            } else {
                this.setState({ existCNPJAndUnit: false });
            }
        }
    }

    transform = (string) => {
        var novo = string.replace(/[\-()._/]/g, "");
        return novo;
    }

    isEmail = () => {
        let field = document.getElementById('contactEmail').value;
        var usuario = field.substring(0, field.indexOf("@"));
        var dominio = field.substring(field.indexOf("@") + 1, field.length);
        if ((usuario.length >= 1) &&
            (dominio.length >= 3) &&
            (usuario.search("@") == -1) &&
            (dominio.search("@") == -1) &&
            (usuario.search(" ") == -1) &&
            (dominio.search(" ") == -1) &&
            (dominio.search(".") != -1) &&
            (dominio.indexOf(".") >= 1) &&
            (dominio.lastIndexOf(".") < dominio.length - 1)) {
            this.setState({ isEmail: true });
        } else {
            this.setState({ isEmail: false });
        }
    }

    isEmailNew = () => {
        let field = document.getElementById('createEmail').value;
        var usuario = field.substring(0, field.indexOf("@"));
        var dominio = field.substring(field.indexOf("@") + 1, field.length);
        if ((usuario.length >= 1) &&
            (dominio.length >= 3) &&
            (usuario.search("@") == -1) &&
            (dominio.search("@") == -1) &&
            (usuario.search(" ") == -1) &&
            (dominio.search(" ") == -1) &&
            (dominio.search(".") != -1) &&
            (dominio.indexOf(".") >= 1) &&
            (dominio.lastIndexOf(".") < dominio.length - 1)) {
            this.setState({ isEmailNew: true });
        } else {
            this.setState({ isEmailNew: false });
        }
    }

    createCompany = async () => {
        if (this.state.emailValidate && this.state.isEmail) {
            this.setState({ msgErro: null, loadCreate: true, errors: {} });

            let CompanyType = document.getElementById('CompanyTypeId');
            let CompanyTypeText = CompanyType.options[CompanyType.selectedIndex].text;
            let CompanyTypeId = CompanyType.value;

            let socialName = document.getElementById('socialName').value;
            let cnpj = this.transform(document.getElementById('cnpj').value);
            let businessName = document.getElementById('businessName').value;
            let objectOfContract = document.getElementById('objectOfContract').value;
            let phone = this.transform(document.getElementById('phone').value).replace(' ', '');
            let contactEmail = document.getElementById('contactEmail').value;
            let address = document.getElementById('address').value;
            let number = document.getElementById('number').value;
            let complement = document.getElementById('complement').value;
            
            complement = (!complement) ? null : complement; 
            let city = document.getElementById('city').value;
            let state = document.getElementById('state').value;
            let district = document.getElementById('district').value;
            let country = document.getElementById('country').value;
            let cep = this.transform(document.getElementById('cep').value);
            let inscricaoEstadual = document.getElementById('inscricaoEstadual').value;
            inscricaoEstadual = (!inscricaoEstadual) ? null : inscricaoEstadual;
            let contactName = document.getElementById('contactName').value;
            let businessUnit = document.getElementById('businessUnit').value

            if (CompanyTypeText == 'Estrangeiro' && (cep == '' || !cep)) {
                cep = '00000000';
            }
            if (CompanyTypeText == 'Estrangeiro' && (state == '' || !state)) {
                state = 'NA';
            }
            if (CompanyTypeText == 'Estrangeiro' && (city == '' || !city)) {
                city = 'N/A';
            }
            if (CompanyTypeText == 'Estrangeiro' && (district == '' || !district)) {
                district = 'N/A';
            }
            if (CompanyTypeText == 'Estrangeiro' && (address == '' || !address)) {
                address = 'N/A';
            }
            if (CompanyTypeText == 'Estrangeiro' && (number == '' || !number)) {
                number = '00';
            }

            try {
                const result = await api.post(`/companies`, {
                    CompanyTypeId,
                    socialName,
                    cnpj,
                    businessName,
                    phone,
                    contactEmail,
                    address,
                    number,
                    complement,
                    city,
                    state,
                    district,
                    country,
                    cep,
                    inscricaoEstadual,
                    contactName,
                    objectOfContract,
                    businessUnit
                });

                var contacts = this.state.contacts;
                contacts.push({ nome: contactName, email: contactEmail });

                this.setState({
                    idCompanyCreate: result.data.id,
                    companyCreate: true,
                    companyCreateContacts: false,
                    loadCreate: false,
                    contacts: contacts,
                    dataContacts: contacts
                });

            } catch (error) {
                if (error.response && error.response.data) {
                    var errors = error.response.data.errors || [];
                    var msgErro = error.response.data.message || 'Não foi possível cadastrar a empresa! Tente novamente.';
                    this.setState({ errors: errors, msgErro: msgErro, loadCreate: false });
                } else {
                    this.setState({
                        errors: {},
                        msgErro: 'Erro ao cadastrar empresa. Tente novamente.',
                        loadCreate: false
                    });
                }
            }
        } else {
            this.setState({
                errors: {},
                msgErro: 'Por favor, verifique os campos antes de submeter o formulário.'
            });
        }
    }

    verifyValidation = (id) => {
        if (this.state.errors && this.state.errors.length) {
            let dados = this.state.errors.filter((item) => {
                return item.param == id
            });
            if (dados.length) {
                return dados[0].msg;
            } else {
                return false;
            }
        }
    }

    verifyEmail = () => {
        this.isEmail();
        let contactEmail = document.getElementById('contactEmail').value;
        let contactEmail2 = document.getElementById('contactEmail2').value;

        if (contactEmail != contactEmail2) {
            this.setState({ emailValidate: false });
        } else {
            this.setState({ emailValidate: true });
        }
    }

    verifyForm = () => {
        let CompanyTypeId = document.getElementById('CompanyTypeId').value;
        let socialName = document.getElementById('socialName').value;
        let cnpj = this.transform(document.getElementById('cnpj').value);
        let businessName = document.getElementById('businessName').value;
        let phone = this.transform(document.getElementById('phone').value).replace(' ', '');
        let contactEmail = document.getElementById('contactEmail').value;
        let address = document.getElementById('address').value;
        let number = document.getElementById('number').value;
        let city = document.getElementById('city').value;
        let state = document.getElementById('state').value;
        let district = document.getElementById('district').value;
        let country = document.getElementById('country').value;
        let cep = this.transform(document.getElementById('cep').value);
        let inscricaoEstadual = document.getElementById('inscricaoEstadual').value;
        let contactName = document.getElementById('contactName').value;

        if (!this.state.emailValidate ||
            !this.state.isEmail ||
            !CompanyTypeId || !socialName || !cnpj || !businessName || !phone ||
            !contactEmail || !address || !number || !city || !state || !district ||
            !country || !cep || !inscricaoEstadual || !contactName
        ) {
            return true;
        } else {
            return true;
        }
    }

    addContact = () => {
        var createName = document.getElementById("createName").value;
        var createEmail = document.getElementById("createEmail").value;
        if (this.state.isEmailNew) {
            this.state.contacts.push({ nome: createName, email: createEmail });
            this.setState({ dataContacts: this.state.contacts });

            document.getElementById("createName").value = '';
            document.getElementById("createEmail").value = '';
        }
    }

    createContacts = async () => {
        this.setState({ msgErro: null, loadCreate: true });

        try {
            await Promise.all(
                this.state.contacts.map(contact => 
                    api.post(`/companies/${this.state.idCompanyCreate}/contacts`, {
                        name: contact.nome,
                        email: contact.email
                    })
                )
            );

            this.setState({
                companyCreate: false,
                companyCreateContacts: true,
                loadCreate: false
            });

            var second = 20;
            var timer = setInterval(function () {
                var spanElement = document.getElementById('span-seconds');
                if (spanElement) {
                    spanElement.innerHTML = second;
                }
                second--;
                if (second === 0) {
                    clearInterval(timer);
                    window.location.href = "/";
                }
            }, 1000);

        } catch (error) {
            if (error.response && error.response.data) {
                var errors = error.response.data.errors || [];
                var msgErro = error.response.data.message || 'Não foi possível cadastrar os contatos para a empresa! Tente novamente.';
                this.setState({ errors: errors, msgErro: msgErro, loadCreate: false });
            } else {
                this.setState({
                    errors: {},
                    msgErro: 'Erro ao cadastrar contatos. Tente novamente.',
                    loadCreate: false
                });
            }
        }
    }

    renderErrorMessage = () => {
        if (this.state.msgErro) {
            return (
                <div className="alert alert-danger" role="alert">
                    {this.state.msgErro}
                </div>
            );
        }
        return null;
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Cadastro de Empresa
                            {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <form action="javascript:void(0)" id="formCompany">
                    {this.renderErrorMessage()}
                    {(!this.state.companyCreate && !this.state.companyCreateContacts) ?
                        <div>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <h5>CNPJ</h5>
                                        <input type="text" 
                                            maxLength="14" 
                                            data-mask="99.999.999/9999-99" 
                                            id="cnpj" 
                                            onBlur={this.verifyCnpj} 
                                            className={(this.state.existCNPJAndUnit) ? 'form-control form-control-danger input-danger' : "form-control"} 
                                        />
                                        <i className="message-error">{this.verifyValidation('cnpj')}</i>
                                        {(this.state.existCNPJAndUnit) ? <i className="message-error">CNPJ e Unidade de Negócio já existem no sistema</i> : null}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <h5>Unidade de Negócio</h5>
                                        <select 
                                            id="businessUnit" 
                                            className="custom-select col-md-12"
                                            onBlur={this.verifyCnpj}
                                        >
                                            <option value="">Selecione</option>
                                            {
                                                this.state.businessUnits.map((unit, index) => (
                                                    <option key={index} value={unit}>{unit}</option>
                                                ))
                                            }
                                        </select>
                                        <i className="message-error">{this.verifyValidation('businessUnit')}</i>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <h5>Tipo de empresa</h5>
                                    <select className="custom-select col-md-12" name="CompanyTypeId" id="CompanyTypeId" onChange={this.selectSector}>
                                        <option value="">Selecione</option>
                                        {
                                            (this.state.companyTypes.length) ?
                                                this.state.companyTypes.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.id}>{item.description}</option>
                                                    )
                                                })
                                                : null
                                        }
                                    </select>
                                    <i className="message-error">{this.verifyValidation('CompanyTypeId')}</i>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <h5>Razão Social</h5>
                                        <input type="text" id="socialName" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('socialName')}</i>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <h5>Inscrição Estadual</h5>
                                        <input type="text" id="inscricaoEstadual" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('inscricaoEstadual')}</i>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <h5>Nome Fantasia</h5>
                                        <input type="text" id="businessName" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('businessName')}</i>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="form-group">
                                        <h5>CEP</h5>
                                        <input type="text" id="cep" data-mask="99.999-999" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('cep')}</i>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <h5>País</h5>
                                        <input type="text" id="country" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('country')}</i>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <h5>UF</h5>
                                        <select id="state" className="custom-select col-12">
                                            <option></option>
                                            {
                                                (this.state.states.length) ?
                                                    this.state.states.map((item) => {
                                                        return (<option key={item.sigla}>{item.sigla}</option>);
                                                    })
                                                    : null
                                            }
                                        </select>
                                        <i className="message-error">{this.verifyValidation('state')}</i>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <h5>Cidade</h5>
                                        <input type="text" id="city" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('city')}</i>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <h5>Bairro</h5>
                                        <input type="text" id="district" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('district')}</i>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h5>Endereço</h5>
                                        <input type="text" id="address" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('address')}</i>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <h5>Número</h5>
                                        <input type="number" id="number" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('number')}</i>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <h5>Complemento</h5>
                                        <input type="text" id="complement" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('complement')}</i>
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    <div className="form-group">
                                        <h5>Objeto de Contrato</h5>
                                        <input type="text" id="objectOfContract" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('objectOfContract')}</i>
                                    </div>
                                </div>
                            </div>

                            <div className="row contato">
                                <div className="col-md-12">
                                    <h4>Contato principal</h4>
                                </div>
                                <div className="col-md-9">
                                    <div className="form-group">
                                        <h5>Nome</h5>
                                        <input type="text" id="contactName" className="form-control" />
                                        <i className="message-error">{this.verifyValidation('contactName')}</i>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="form-group">
                                        <h5>Telefone</h5>
                                        <input type="text" id="phone" className="form-control" data-mask="(99) 9999-9999?9" />
                                        <i className="message-error">{this.verifyValidation('phone')}</i>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h5>Email</h5>
                                        <input type="email" id="contactEmail" className="form-control" onChange={this.verifyEmail} />
                                        <i className="message-error">{this.verifyValidation('contactEmail')}</i>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h5>Digite o email novamente</h5>
                                        <input type="email" id="contactEmail2" className="form-control" onChange={this.verifyEmail} />
                                        {(!this.state.emailValidate) ? <i className="message-error">Os emails devem ser iguais</i> : null}
                                        {(!this.state.isEmail) ? <i className="message-error"> - Email inválido</i> : null}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 text-right">
                                    <div className="form-actions">
                                        {(this.state.loadCreate) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                        <button disabled={(this.state.loadCreate)} onClick={this.createCompany} className="btn btn-info"> <i className="fa fa-arrow-right"></i> Avançar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null}

                    {(this.state.companyCreate) ?
                        <div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-info">
                                        Cadastre aqui os contatos da empresa que acessarão o sistema.
                        </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <h5>Nome</h5>
                                        <input type="text" id="createName" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <h5>Email</h5>
                                        <input type="text" id="createEmail" className="form-control col-md-10" onKeyUp={this.isEmailNew} />
                                        <button disabled={!this.state.isEmailNew} onClick={this.addContact} className="btn btn-success col-md-2"> <i className="fa fa-plus"></i></button>
                                        {(!this.state.isEmailNew) ? <i className="message-error">Email inválido</i> : null}

                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <td><strong>Nome</strong></td>
                                                <td><strong>Email</strong></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                (this.state.dataContacts.length) ?
                                                    this.state.dataContacts.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    {item.nome}
                                                                </td>
                                                                <td>
                                                                    {item.email}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    : null
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 text-right">
                                    <div className="form-actions">
                                        {(this.state.loadCreate) ? <i className="fa fa-spin fa-spinner"></i> : null}
                                        <button disabled={(this.state.loadCreate)} onClick={this.createContacts} className="btn btn-success"> <i className="fa fa-check"></i> Concluir</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null}

                    {(this.state.companyCreateContacts) ?
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className="mdi mdi-check text-success"></h1>
                                <h1 className="text-uppercase text-success">Sucesso!</h1><br />
                                <h2>
                                    Seus dados foram enviados para avaliação de cadastro.<br />
                                    Após confirmados, você receberá um e-mail para realizar o envio dos documentos.
                                </h2>
                                <br /><br />
                                Aguarde... Você será redirecionado em <strong id="span-seconds">10</strong>.
                        </div>
                        </div>
                        : null}

                </form>

            </Fragment >
        )
    }

}

export default Company;